export default ['contains_lowercase', 'contains_uppercase', 'contains_numeric', 'contains_symbol']
